import React from 'react'

interface FooterProps {
  className?: string
}

export default function Footer({ className }: FooterProps) {
  return (
    <footer className={`relative z-10 border-t border-white/5 bg-transparent py-12 ${className}`}>
      <div className="container mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="text-slate-500 text-sm">
          © {new Date().getFullYear()} LogicNext Inc. All rights reserved.
        </div>
        <div className="flex gap-6">
          {/* Social placeholders */}
          <div className="w-5 h-5 bg-slate-800 rounded-full" />
          <div className="w-5 h-5 bg-slate-800 rounded-full" />
          <div className="w-5 h-5 bg-slate-800 rounded-full" />
        </div>
      </div>
    </footer>
  )
}
